import { IssuesModal, FollowUpModal, HealthcheckModal, ModalCallbacksConfig } from 'domain/shared/core/dashboard';
import { DashboardModalConfig } from 'framework/ui/dashboard';

export const getEmployeeDashboardModals = (modalCallbacks: ModalCallbacksConfig): DashboardModalConfig[] => [
  {
    key: 'issues',
    title: 'Manage Issues',
    component: IssuesModal,
    maxWidth: 'lg',
    callbacks: modalCallbacks.issues,
  },
  {
    key: 'followUp',
    title: 'Add Follow Up',
    component: FollowUpModal,
    maxWidth: 'md',
    callbacks: modalCallbacks.followUp,
  },
  {
    key: 'healthcheck',
    title: 'Conduct Healthcheck',
    component: HealthcheckModal,
    maxWidth: 'md',
    callbacks: modalCallbacks.healthcheck,
  },
  {
    key: 'changeZone',
    title: 'Change Worker Zone',
    component: IssuesModal,
    maxWidth: 'lg',
    callbacks: modalCallbacks.changeZone,
  },
];
